import AbstractFormField from './AbstractFormField';

class TextareaFormField extends AbstractFormField {
    constructor(element, options) {
        super(element, { ...options, type: 'textarea' });
        this.input = element.querySelectorAll('textarea')[0];
        this.input.addEventListener('keyup', this.handleChanges.bind(this));
    }

    getValue() {
        return this.input ? this.input.value : '';
    }
    setValue(value) {
        this.input.value = value;
    }

    isValid() {
        if (!this.isRequired) {
            return true;
        }

        return this.input.value.trim() !== '';
    }
}

export default TextareaFormField;
